angular.module('app')
  .directive('mediathequeBiblioExpertSearchResults', BiblioExpertSearchResultsDirective);

function BiblioExpertSearchResultsDirective() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      results: '&mediathequeSearchResults',
      loaded: '&mediathequeSearchLoaded',
      loading: '&mediathequeSearchLoading'
    },
    controller: BiblioExpertSearchResultsController,
    controllerAs: 'expertSearchResultsCtrl',
    templateUrl: 'biblio/biblio-expert-search-results.html'
  };
}

/*@ngInject*/
function BiblioExpertSearchResultsController($scope, $rootScope, ExpertSearch) {
  var expertSearchResultsCtrl = this;

  expertSearchResultsCtrl.results = null;
  expertSearchResultsCtrl.loading = false;
  expertSearchResultsCtrl.loaded = false;
  $scope.$watch($scope.results, (newResults) => {
    expertSearchResultsCtrl.results = newResults;
  });
  $scope.$watch($scope.loading, (loading) => {
    expertSearchResultsCtrl.loading = loading;
  });
  $scope.$watch($scope.loaded, (loaded) => {
    expertSearchResultsCtrl.loaded = loaded;
  });

  expertSearchResultsCtrl.displayNextResults = displayNextResults;
  expertSearchResultsCtrl.displayAllResults = displayAllResults;
  expertSearchResultsCtrl.hasMoreResults = ExpertSearch.hasMoreResults;
  expertSearchResultsCtrl.toggleResult = toggleResult;

  function displayNextResults() {
    $rootScope.$emit('expert-search-next', 'Biblio');
  }

  function displayAllResults() {
    $rootScope.$emit('expert-search-all', 'Biblio');
  }

  function toggleResult(result) {
    $rootScope.$emit('expert-search-toggle-result', result.id);
  }
}
